import { OdinIcon } from '@myosh/odin-components';

interface OdinLoadingIndicatorProps {
  label?: string;
}

/** An alternative loading indicator */
const OdinLoadingIndicator = ({ label }: OdinLoadingIndicatorProps) => {
  return (
    <div className="flex w-full items-center justify-center overflow-hidden">
      <OdinIcon icon="RefreshCw" spin={true} />
      {label && <span className="pl-1">{label}</span>}
    </div>
  );
};

export default OdinLoadingIndicator;
